'use client';

import { AuthLayout, CInstaClubVector, SignInForm } from '@insta-club/components';

function SignIn() {
    return (
        <AuthLayout
            title={<CInstaClubVector height={20} />}
            description={{
                title: 'خوش آمدید',
                text: 'برای ورود به حساب کاربری شماره تلفن همراه یا ایمیل خود را وارد کنید.'
            }}
            guideKey='login'
        >
            <SignInForm />
        </AuthLayout>
    );
}

export default SignIn;

